import React from 'react';
import { useTranslation } from 'react-i18next';
import { MCheckbox } from '../../../../horizon-components/MCheckbox/MCheckbox';
import { Topic } from '../../../../models/Course';

type Props = {
  topic?: Topic | null;
};

export const CoursePreviewTopicTest: React.FC<Props> = ({ topic }) => {
  const { t } = useTranslation(['translation']);

  if (!topic) return null;

  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <div className={'text-sm font-bold md:text-lg'}>
          {t('edu.Topic_test')} ({t('optional')})
        </div>
      </div>
      <div className={'flex flex-col gap-8'}>
        {topic?.questions?.map((question, index) => (
          <div className={'flex flex-col gap-3'}>
            <div
              className={
                'flex gap-2 text-sm font-semibold text-secondary-dark-grey-900 md:text-base'
              }
            >
              <span className="font-semibold">{index + 1}.</span>
              <div
                className={'w-full font-medium'}
                dangerouslySetInnerHTML={{ __html: question.text }}
              />
            </div>
            {question.topic_answers.map((answer) => (
              <MCheckbox
                key={answer.id}
                checked={answer.correct}
                type={question.is_multiple_answers ? 'checkbox' : 'radio'}
                text={answer.text}
                id={`answer${answer.id}index${index + 1}`}
                disabled
              />
            ))}
          </div>
        ))}
      </div>
    </>
  );
};
